import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  question: {
    byId: {},
    allIds: []
  },
  userResponses: {
    byId: {},
    isSuperQuiz: false
  },
  randomQuizQuestions: {},
  comingFromProgression: false,
  firebaseId: null,
  quizzes: [],
  currentQuiz: null
}

export default {
  state,
  getters,
  actions,
  mutations
}
